.button {
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  outline: none;
  transition: var(--normal-s);
  white-space: nowrap;

  &.variant\: {
    &primary-soft,
    &primary-hard {
      background: var(--inverse);
      color: var(--strong-on-inverse);

      &:disabled {
        background: var(--weak-on-dugout);
        color: var(--on-primary);
      }

      @media (hover: hover) {
        &:hover:not(:disabled) {
          transform: scale(1.015);
        }
      }
    }
    &secondary {
      color: var(--strong);

      &.floating {
        box-shadow: 1px 2px 4px 1px var(--outline);
      }
    }
    &outlined {
      box-shadow: inset 0 0 0 1px var(--strong);
      color: var(--strong);
    }
    &destructive {
      color: var(--error);
    }
    &destructive,
    &secondary {
      background: var(--container);
      text-decoration: underline;
    }
    &text {
      background: var(--container);
      color: var(--strong);
    }
    &text-primary {
      background: var(--container);
      color: var(--primary);
    }
    &destructive-dugout {
      background: var(--dugout);
      color: var(--error);
    }
  }

  &.size\: {
    &small {
      height: 32px;
      padding: 0 12px;
      border-radius: 24px;
    }
    &large {
      width: 100%;
      max-width: 400px;
    }
    &large,
    &standard,
    &full-width {
      height: 48px;
      padding: 0 24px;
      border-radius: 32px;
    }
    &full-width {
      width: 100%;
    }
  }
  &:disabled {
    opacity: 0.7;
  }
}
